// extracted by mini-css-extract-plugin
export default {"errorMessage":"styles_errorMessage__T3wA-","subtitleWrapper":"styles_subtitleWrapper__aBaLb","errorMessageText":"styles_errorMessageText__7HtbI"};